import { render, staticRenderFns } from "./userRow.vue?vue&type=template&id=1d5dd61a&scoped=true"
import script from "./userRow.vue?vue&type=script&lang=js"
export * from "./userRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5dd61a",
  null
  
)

export default component.exports